import { render, staticRenderFns } from "./LogoWithFallback.vue?vue&type=template&id=9a0d4aa8&scoped=true&"
import script from "./LogoWithFallback.vue?vue&type=script&lang=ts&"
export * from "./LogoWithFallback.vue?vue&type=script&lang=ts&"
import style0 from "./LogoWithFallback.vue?vue&type=style&index=0&id=9a0d4aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0d4aa8",
  null
  
)

export default component.exports